import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import {
  waterForFireFightersFilterWaterList,
  waterForFireFightersTubewellWaterList,
  waterForFireFightersUnfilterWaterList,
  WaterSupplyLeftNavsList,
} from "../utils/constants";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { RenderNavItem } from "../components/RenderNavItem";

const Water_For_Fire_Fighter = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> Water For Fire Fighters </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {WaterSupplyLeftNavsList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass"> Water For Fire Fighters </h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <p className="fontSizeClass">
                      A List of locations of water supply pumping stations is
                      given below where fire fighters may access to get water
                      through spout.
                    </p>
                  </div>
                  <div className="mayor-table min-height-400">
                    <table className="table table-bordered">
                      <thead>
                        <tr className="table-warning table-bor-2">
                          <th width="10" className="bd-wid" scope="col">
                            Sl.
                          </th>
                          <th width="35" scope="col">
                            Water Supply installations
                          </th>
                          <th width="35" scope="col">
                            Location
                          </th>
                          <th width="20" className="table-bor-3" scope="col">
                            View Map
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td> (Filter water) </td>
                          <td> &nbsp; </td>
                          <td> &nbsp; </td>
                          <td> &nbsp; </td>
                        </tr>
                        {waterForFireFightersFilterWaterList.map(
                          (item, index) => (
                            <tr key={item.fileStoreId}>
                              <td>{index + 1}</td>
                              <td>{item.waterSupplyInstallations}</td>
                              <td>{item.location}</td>
                              <td>
                                <DownloadFileByFileStoreId
                                  fileStoreId={item.fileStoreId}
                                  label={"Click Here"}
                                />
                              </td>
                            </tr>
                          )
                        )}
                        <tr>
                          <td> (Unfilter water) </td>
                          <td> &nbsp; </td>
                          <td> &nbsp; </td>
                          <td> &nbsp; </td>
                        </tr>
                        {waterForFireFightersUnfilterWaterList.map(
                          (item, index) => (
                            <tr key={item.fileStoreId}>
                              <td>{index + 11}</td>
                              <td>{item.waterSupplyInstallations}</td>
                              <td>{item.location}</td>
                              <td>
                                <DownloadFileByFileStoreId
                                  fileStoreId={item.fileStoreId}
                                  label={"Click Here"}
                                />
                              </td>
                            </tr>
                          )
                        )}
                        <tr>
                          <td> (Tubewell water) </td>
                          <td> &nbsp; </td>
                          <td> &nbsp; </td>
                          <td> &nbsp; </td>
                        </tr>
                        {waterForFireFightersTubewellWaterList.map(
                          (item, index) => (
                            <tr key={item.fileStoreId}>
                              <td>{index + 12}</td>
                              <td>{item.waterSupplyInstallations}</td>
                              <td>{item.location}</td>
                              <td>
                                <DownloadFileByFileStoreId
                                  fileStoreId={item.fileStoreId}
                                  label={"Click Here"}
                                />
                              </td>
                            </tr>
                          )
                        )}
                        {/* <tr>
                          <td> (Filter water) </td>
                          <td> &nbsp; </td>
                          <td> &nbsp; </td>
                          <td> &nbsp; </td>
                        </tr>
                        <tr>
                          <td> 1 </td>
                          <td> Tallah Pumping Station </td>
                          <td> The low level road of Tallah bridge </td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/outside_images/Tallah_Pumping_Station.jpg`}
                              target="_blank"
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 2. </td>
                          <td> Jorabagan Pumping Station </td>
                          <td>
                            Inside the pumping station beside Baishnab Sett
                            Street
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/outside_images/Jorabagan_Pumping_Station.jpg`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 3. </td>
                          <td> Raja Subodh Mullick Sq. BPS </td>
                          <td>
                            At the junction of Creek Row &amp; Raja Subodh
                            Mullick Sq.
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/outside_images/Raja_Subodh_Mullick_Sq_%20BPS.jpg`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 4. </td>
                          <td>Auckland Sq. BPS </td>
                          <td>
                            At the junction of A.J.C. Bose Road &amp; Auckland
                            Place, near 'Mouchak'.
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/outside_images/Auckland_Sq_BPS.jpg`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 5 </td>
                          <td> Park Circus BPS </td>
                          <td>
                            At the junction of Orient Row &amp; New Park Street.
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/outside_images/Park_Circus_BPS.jpg`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 6 </td>
                          <td> Kalighat BPS </td>
                          <td> Near Kalighat Tram Depot </td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/outside_images/Kalighat_BPS.jpg`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 7 </td>
                          <td> Kasba BPS </td>
                          <td>
                            At the junction of Rashbehari Connector &amp; Bose
                            Pukur Road
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/outside_images/Kasba_BPS.jpg`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 8 </td>
                          <td>Ranikuthi BPS </td>
                          <td> Near Ranikuthi Telephone Exchange</td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/outside_images/Ranikuthi_BPS.jpg`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 9 </td>
                          <td> Behala BPS </td>
                          <td>
                            At the junction of Behala Chowrasta on Ho-Chi-Minh
                            Sarani
                          </td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/outside_images/Behala_BPS.jpg`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 10 </td>
                          <td> Garden Reach Water Works </td>
                          <td> Within the GRWW campus near Nature Park</td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/outside_images/Garden_Reach_Water_Works.jpg`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> (Unfilter water) </td>
                          <td> &nbsp; </td>
                          <td> &nbsp; </td>
                          <td> &nbsp; </td>
                        </tr>
                        <tr>
                          <td> 11 </td>
                          <td> Mullick Ghat Pumping Station </td>
                          <td> Adjacent to Brabourne Road fly-over </td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/outside_images/Mullick_Ghat_Pumping_Station.jpg`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 12 </td>
                          <td> Prince Anwar Shah Road </td>
                          <td> Near South City </td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/outside_images/Prince_Anwar_Shah_Road.jpg`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 13 </td>
                          <td>
                            Big Dia Meter Tubewell Spout Arupota, Dhapa, South
                            Sealdh
                          </td>
                          <td> South Part of EM Bypass (ward 57,58) </td>
                          <td>
                            <a
                              href={`${mainURL}/KMCPortal/downloads/Spout_WD_57_58_Final.pdf`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 14 </td>
                          <td>
                            Big Dia Meter Tubewell Spout CREMATORIUM
                            STREET,SHARIF LANE CROSSING
                          </td>
                          <td> Park Circus Tram Depo.(ward 61,62) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 15 </td>
                          <td>
                            Big Dia Meter Tubewell Spout TILJALA, TOPSIA, G J
                            KHAN RD, CHOWBHAGA, KUSTIA
                          </td>
                          <td>
                            7 point Park Circus-EM By Pass Connector (Ward 66)
                          </td>
                          <td>
                            <a onClick={(e) => fileDownload("846")}>
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 16 </td>
                          <td>
                            Big Dia Meter Tubewell Spout PICNIC Garden, KASHBA
                            BPS
                          </td>
                          <td> Rash Behari Bypass Connector(ward 67) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 17 </td>
                          <td>Big Dia Meter Tubewell Spout EKDALIA, KAKULIA</td>
                          <td>Gariahat Area(ward : 68) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 18 </td>
                          <td>
                            Big Dia Meter Tubewell Spout St. Lawrence High
                            School
                          </td>
                          <td> Ballygunge Phari area(Ward 69) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18004926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 19 </td>
                          <td>
                            Big Dia Meter Tubewell Spout Harish Chatterjee St.,
                            Kalighat
                          </td>
                          <td> Bhowbanipur Area(Ward 73) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 20 </td>
                          <td>
                            Big Dia Meter Tubewell Spout DURGAPUR LANE,
                            BELVEDERE ROAD
                          </td>
                          <td>Alipore Area (Ward 74) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 21 </td>
                          <td>Big Dia Meter Tubewell Spout EKBALPORE </td>
                          <td> EKBALPORE area(Ward 78) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 22 </td>
                          <td>
                            Big Dia Meter Tubewell Spout JHALDAR MATH, CHETLA ,
                            KALIGHAT
                          </td>
                          <td> Chtla, Kalighat area.(Ward 81,82,83,88) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 23 </td>
                          <td>
                            Big Dia Meter Tubewell Spout Charu Avenue, Swiss
                            Park
                          </td>
                          <td> Charu Avenue, Swiss Park area(Ward : 89) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 24 </td>
                          <td>
                            Big Dia Meter Tubewell Spout Kolupara, Bose Pukur
                          </td>
                          <td> Rash Behari Bypass Connector(ward 91) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 25 </td>
                          <td>
                            Big Dia Meter Tubewell Spout SAHID NAGAR, New Land,
                            Nashkar Para
                          </td>
                          <td> Dhakuria Area(Ward 92) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 26 </td>
                          <td>
                            Big Dia Meter Tubewell Spout Katjunagar, Lake
                            Gardens
                          </td>
                          <td> Jodhpur Park Area(Ward 93) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 27 </td>
                          <td> Tubewell Fire Spout </td>
                          <td> NEW MARKET (Ward 46) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 28 </td>
                          <td> Tubewell Fire Spout </td>
                          <td> CHAPLIN SQUARE (Ward 46) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 29 </td>
                          <td> Tubewell Fire Spout </td>
                          <td> NANDARAM MARKET(Ward 45) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18005926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 30 </td>
                          <td> Tubewell Fire Spout </td>
                          <td> PARTUGUESE CHURCH STREET (Ward 45) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18006026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 31 </td>
                          <td> Tubewell Fire Spout</td>
                          <td> 18-RABINDRA SARANI(Ward 43) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18006126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 32 </td>
                          <td> Tubewell Fire Spout </td>
                          <td> TARACHAND DUTTA STREET(Ward 44) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18006226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 33 </td>
                          <td> Tubewell Fire Spout </td>
                          <td> ORPHANGUNGE MARKET(Ward 77) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18006326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 34 </td>
                          <td> Tubewell Fire Spout </td>
                          <td> RAJABAZAR CROSSING(Ward 36) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18006426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 35 </td>
                          <td> Tubewell Fire Spout </td>
                          <td> HATIBAGAN(Ward 11) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18006526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td> 36 </td>
                          <td> Tubewell Fire Spout </td>
                          <td> AKHIL MISTRY LANE(Ward 49) </td>
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18006626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Click Here
                            </a>
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Water_For_Fire_Fighter;
